module.exports = __webpack_public_path__ + "img/completed.99d237f1.svg";